/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Footer_Web_LoginInputs */

const en_app_footer_web_login = /** @type {(inputs: App_Footer_Web_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Login`)
};

const es_app_footer_web_login = /** @type {(inputs: App_Footer_Web_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso web`)
};

/**
* | output |
* | --- |
* | "Web Login" |
*
* @param {App_Footer_Web_LoginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_footer_web_login = /** @type {((inputs?: App_Footer_Web_LoginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Footer_Web_LoginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_footer_web_login(inputs)
	return en_app_footer_web_login(inputs)
});